import React from 'react';
import MapButton from './MapButton';
import FitViewSvg from 'assets/fit_view.svg?react';

export interface FitViewControlProps {
  callback: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const FitViewControl: React.FC<FitViewControlProps> = ({ callback }) => {
  return (
    <div>
      <MapButton
        id="fitView"
        className="rounded-4 w-40px bg-white h-40px flex items-center justify-center"
        callback={callback}
        tooltipText="Fit view to selected fields"
      >
        <FitViewSvg />
      </MapButton>
    </div>
  );
};

export default FitViewControl;
